@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.transfer_interbank.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.transfer_interbank.generated.resources/"

internal val Res.string.feature_send_interbank_account: StringResource by lazy {
      StringResource("string:feature_send_interbank_account", "feature_send_interbank_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78, 66),
      ))
    }

internal val Res.string.feature_send_interbank_account_type: StringResource by lazy {
      StringResource("string:feature_send_interbank_account_type", "feature_send_interbank_account_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 67),
      ))
    }

internal val Res.string.feature_send_interbank_acknowledgement_section: StringResource by lazy {
      StringResource("string:feature_send_interbank_acknowledgement_section", "feature_send_interbank_acknowledgement_section", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 145, 86),
      ))
    }

internal val Res.string.feature_send_interbank_amount: StringResource by lazy {
      StringResource("string:feature_send_interbank_amount", "feature_send_interbank_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 464, 45),
      ))
    }

internal val Res.string.feature_send_interbank_amount_exceeds_balance: StringResource by lazy {
      StringResource("string:feature_send_interbank_amount_exceeds_balance", "feature_send_interbank_amount_exceeds_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 232, 97),
      ))
    }

internal val Res.string.feature_send_interbank_amount_label: StringResource by lazy {
      StringResource("string:feature_send_interbank_amount_label", "feature_send_interbank_amount_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330, 59),
      ))
    }

internal val Res.string.feature_send_interbank_amount_transferred: StringResource by lazy {
      StringResource("string:feature_send_interbank_amount_transferred", "feature_send_interbank_amount_transferred", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 390, 73),
      ))
    }

internal val Res.string.feature_send_interbank_attempted_amount: StringResource by lazy {
      StringResource("string:feature_send_interbank_attempted_amount", "feature_send_interbank_attempted_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 510, 71),
      ))
    }

internal val Res.string.feature_send_interbank_available_balance: StringResource by lazy {
      StringResource("string:feature_send_interbank_available_balance", "feature_send_interbank_available_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 661, 80),
      ))
    }

internal val Res.string.feature_send_interbank_available_balance_label: StringResource by lazy {
      StringResource("string:feature_send_interbank_available_balance_label", "feature_send_interbank_available_balance_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 582, 78),
      ))
    }

internal val Res.string.feature_send_interbank_back_to_home: StringResource by lazy {
      StringResource("string:feature_send_interbank_back_to_home", "feature_send_interbank_back_to_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 742, 59),
      ))
    }

internal val Res.string.feature_send_interbank_balance: StringResource by lazy {
      StringResource("string:feature_send_interbank_balance", "feature_send_interbank_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 802, 58),
      ))
    }

internal val Res.string.feature_send_interbank_bank: StringResource by lazy {
      StringResource("string:feature_send_interbank_bank", "feature_send_interbank_bank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 861, 51),
      ))
    }

internal val Res.string.feature_send_interbank_cancel: StringResource by lazy {
      StringResource("string:feature_send_interbank_cancel", "feature_send_interbank_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 913, 45),
      ))
    }

internal val Res.string.feature_send_interbank_choose_account_to_send: StringResource by lazy {
      StringResource("string:feature_send_interbank_choose_account_to_send", "feature_send_interbank_choose_account_to_send", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 959, 117),
      ))
    }

internal val Res.string.feature_send_interbank_confirm_pay: StringResource by lazy {
      StringResource("string:feature_send_interbank_confirm_pay", "feature_send_interbank_confirm_pay", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1077, 62),
      ))
    }

internal val Res.string.feature_send_interbank_contact_support: StringResource by lazy {
      StringResource("string:feature_send_interbank_contact_support", "feature_send_interbank_contact_support", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1140, 66),
      ))
    }

internal val Res.string.feature_send_interbank_continue: StringResource by lazy {
      StringResource("string:feature_send_interbank_continue", "feature_send_interbank_continue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1207, 51),
      ))
    }

internal val Res.string.feature_send_interbank_date: StringResource by lazy {
      StringResource("string:feature_send_interbank_date", "feature_send_interbank_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1259, 59),
      ))
    }

internal val Res.string.feature_send_interbank_description: StringResource by lazy {
      StringResource("string:feature_send_interbank_description", "feature_send_interbank_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1319, 74),
      ))
    }

internal val Res.string.feature_send_interbank_download_receipt: StringResource by lazy {
      StringResource("string:feature_send_interbank_download_receipt", "feature_send_interbank_download_receipt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1394, 71),
      ))
    }

internal val Res.string.feature_send_interbank_edit: StringResource by lazy {
      StringResource("string:feature_send_interbank_edit", "feature_send_interbank_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1531, 43),
      ))
    }

internal val Res.string.feature_send_interbank_edit_transfer: StringResource by lazy {
      StringResource("string:feature_send_interbank_edit_transfer", "feature_send_interbank_edit_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1466, 64),
      ))
    }

internal val Res.string.feature_send_interbank_enter_amount: StringResource by lazy {
      StringResource("string:feature_send_interbank_enter_amount", "feature_send_interbank_enter_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1575, 59),
      ))
    }

internal val Res.string.feature_send_interbank_enter_phone_number: StringResource by lazy {
      StringResource("string:feature_send_interbank_enter_phone_number", "feature_send_interbank_enter_phone_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1635, 73),
      ))
    }

internal val Res.string.feature_send_interbank_enter_phone_to_search: StringResource by lazy {
      StringResource("string:feature_send_interbank_enter_phone_to_search", "feature_send_interbank_enter_phone_to_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1709, 112),
      ))
    }

internal val Res.string.feature_send_interbank_error: StringResource by lazy {
      StringResource("string:feature_send_interbank_error", "feature_send_interbank_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2567, 52),
      ))
    }

internal val Res.string.feature_send_interbank_error_amount_greater_than_zero: StringResource by
    lazy {
      StringResource("string:feature_send_interbank_error_amount_greater_than_zero", "feature_send_interbank_error_amount_greater_than_zero", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1822, 101),
      ))
    }

internal val Res.string.feature_send_interbank_error_enter_amount: StringResource by lazy {
      StringResource("string:feature_send_interbank_error_enter_amount", "feature_send_interbank_error_enter_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1924, 81),
      ))
    }

internal val Res.string.feature_send_interbank_error_enter_description: StringResource by lazy {
      StringResource("string:feature_send_interbank_error_enter_description", "feature_send_interbank_error_enter_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2006, 90),
      ))
    }

internal val Res.string.feature_send_interbank_error_failed_to_search_recipient: StringResource by
    lazy {
      StringResource("string:feature_send_interbank_error_failed_to_search_recipient", "feature_send_interbank_error_failed_to_search_recipient", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2097, 99),
      ))
    }

internal val Res.string.feature_send_interbank_error_invalid_amount: StringResource by lazy {
      StringResource("string:feature_send_interbank_error_invalid_amount", "feature_send_interbank_error_invalid_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2197, 71),
      ))
    }

internal val Res.string.feature_send_interbank_error_phone_number_digits: StringResource by lazy {
      StringResource("string:feature_send_interbank_error_phone_number_digits", "feature_send_interbank_error_phone_number_digits", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2269, 108),
      ))
    }

internal val Res.string.feature_send_interbank_error_select_recipient: StringResource by lazy {
      StringResource("string:feature_send_interbank_error_select_recipient", "feature_send_interbank_error_select_recipient", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2378, 89),
      ))
    }

internal val Res.string.feature_send_interbank_error_select_sender_account: StringResource by lazy {
      StringResource("string:feature_send_interbank_error_select_sender_account", "feature_send_interbank_error_select_sender_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2468, 98),
      ))
    }

internal val Res.string.feature_send_interbank_exchange_rate_info: StringResource by lazy {
      StringResource("string:feature_send_interbank_exchange_rate_info", "feature_send_interbank_exchange_rate_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2620, 85),
      ))
    }

internal val Res.string.feature_send_interbank_failed: StringResource by lazy {
      StringResource("string:feature_send_interbank_failed", "feature_send_interbank_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2706, 45),
      ))
    }

internal val Res.string.feature_send_interbank_found_recipients: StringResource by lazy {
      StringResource("string:feature_send_interbank_found_recipients", "feature_send_interbank_found_recipients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2752, 79),
      ))
    }

internal val Res.string.feature_send_interbank_from_account: StringResource by lazy {
      StringResource("string:feature_send_interbank_from_account", "feature_send_interbank_from_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2898, 59),
      ))
    }

internal val Res.string.feature_send_interbank_from_account_label: StringResource by lazy {
      StringResource("string:feature_send_interbank_from_account_label", "feature_send_interbank_from_account_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2832, 65),
      ))
    }

internal val Res.string.feature_send_interbank_i_acknowledged: StringResource by lazy {
      StringResource("string:feature_send_interbank_i_acknowledged", "feature_send_interbank_i_acknowledged", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2958, 65),
      ))
    }

internal val Res.string.feature_send_interbank_id: StringResource by lazy {
      StringResource("string:feature_send_interbank_id", "feature_send_interbank_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3024, 37),
      ))
    }

internal val Res.string.feature_send_interbank_no_accounts: StringResource by lazy {
      StringResource("string:feature_send_interbank_no_accounts", "feature_send_interbank_no_accounts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3183, 58),
      ))
    }

internal val Res.string.feature_send_interbank_no_accounts_available: StringResource by lazy {
      StringResource("string:feature_send_interbank_no_accounts_available", "feature_send_interbank_no_accounts_available", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3062, 120),
      ))
    }

internal val Res.string.feature_send_interbank_no_recipients_found: StringResource by lazy {
      StringResource("string:feature_send_interbank_no_recipients_found", "feature_send_interbank_no_recipients_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3242, 106),
      ))
    }

internal val Res.string.feature_send_interbank_no_results: StringResource by lazy {
      StringResource("string:feature_send_interbank_no_results", "feature_send_interbank_no_results", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3349, 57),
      ))
    }

internal val Res.string.feature_send_interbank_office: StringResource by lazy {
      StringResource("string:feature_send_interbank_office", "feature_send_interbank_office", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3407, 53),
      ))
    }

internal val Res.string.feature_send_interbank_ok: StringResource by lazy {
      StringResource("string:feature_send_interbank_ok", "feature_send_interbank_ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3461, 37),
      ))
    }

internal val Res.string.feature_send_interbank_oops: StringResource by lazy {
      StringResource("string:feature_send_interbank_oops", "feature_send_interbank_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3499, 43),
      ))
    }

internal val Res.string.feature_send_interbank_preview_transfer: StringResource by lazy {
      StringResource("string:feature_send_interbank_preview_transfer", "feature_send_interbank_preview_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3543, 71),
      ))
    }

internal val Res.string.feature_send_interbank_retry_transfer: StringResource by lazy {
      StringResource("string:feature_send_interbank_retry_transfer", "feature_send_interbank_retry_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3615, 65),
      ))
    }

internal val Res.string.feature_send_interbank_review_transfer: StringResource by lazy {
      StringResource("string:feature_send_interbank_review_transfer", "feature_send_interbank_review_transfer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3755, 74),
      ))
    }

internal val Res.string.feature_send_interbank_review_transfer_button: StringResource by lazy {
      StringResource("string:feature_send_interbank_review_transfer_button", "feature_send_interbank_review_transfer_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3681, 73),
      ))
    }

internal val Res.string.feature_send_interbank_search_recipient: StringResource by lazy {
      StringResource("string:feature_send_interbank_search_recipient", "feature_send_interbank_search_recipient", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3830, 71),
      ))
    }

internal val Res.string.feature_send_interbank_select_account: StringResource by lazy {
      StringResource("string:feature_send_interbank_select_account", "feature_send_interbank_select_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3902, 65),
      ))
    }

internal val Res.string.feature_send_interbank_select_your_account: StringResource by lazy {
      StringResource("string:feature_send_interbank_select_your_account", "feature_send_interbank_select_your_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3968, 78),
      ))
    }

internal val Res.string.feature_send_interbank_success: StringResource by lazy {
      StringResource("string:feature_send_interbank_success", "feature_send_interbank_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4047, 50),
      ))
    }

internal val Res.string.feature_send_interbank_terms_acknowledged: StringResource by lazy {
      StringResource("string:feature_send_interbank_terms_acknowledged", "feature_send_interbank_terms_acknowledged", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4352, 73),
      ))
    }

internal val Res.string.feature_send_interbank_terms_acknowledged_description: StringResource by
    lazy {
      StringResource("string:feature_send_interbank_terms_acknowledged_description", "feature_send_interbank_terms_acknowledged_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4098, 253),
      ))
    }

internal val Res.string.feature_send_interbank_to_account: StringResource by lazy {
      StringResource("string:feature_send_interbank_to_account", "feature_send_interbank_to_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4562, 57),
      ))
    }

internal val Res.string.feature_send_interbank_to_account_interbank: StringResource by lazy {
      StringResource("string:feature_send_interbank_to_account_interbank", "feature_send_interbank_to_account_interbank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4426, 71),
      ))
    }

internal val Res.string.feature_send_interbank_to_account_label: StringResource by lazy {
      StringResource("string:feature_send_interbank_to_account_label", "feature_send_interbank_to_account_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4498, 63),
      ))
    }

internal val Res.string.feature_send_interbank_today: StringResource by lazy {
      StringResource("string:feature_send_interbank_today", "feature_send_interbank_today", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4620, 44),
      ))
    }

internal val Res.string.feature_send_interbank_transaction_date_label: StringResource by lazy {
      StringResource("string:feature_send_interbank_transaction_date_label", "feature_send_interbank_transaction_date_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4665, 77),
      ))
    }

internal val Res.string.feature_send_interbank_transaction_failed: StringResource by lazy {
      StringResource("string:feature_send_interbank_transaction_failed", "feature_send_interbank_transaction_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4743, 157),
      ))
    }

internal val Res.string.feature_send_interbank_transaction_reference: StringResource by lazy {
      StringResource("string:feature_send_interbank_transaction_reference", "feature_send_interbank_transaction_reference", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4901, 80),
      ))
    }

internal val Res.string.feature_send_interbank_transfer_amount: StringResource by lazy {
      StringResource("string:feature_send_interbank_transfer_amount", "feature_send_interbank_transfer_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4982, 66),
      ))
    }

internal val Res.string.feature_send_interbank_transfer_completed: StringResource by lazy {
      StringResource("string:feature_send_interbank_transfer_completed", "feature_send_interbank_transfer_completed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5049, 121),
      ))
    }

internal val Res.string.feature_send_interbank_transfer_details: StringResource by lazy {
      StringResource("string:feature_send_interbank_transfer_details", "feature_send_interbank_transfer_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5171, 71),
      ))
    }

internal val Res.string.feature_send_interbank_transfer_failed: StringResource by lazy {
      StringResource("string:feature_send_interbank_transfer_failed", "feature_send_interbank_transfer_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5243, 66),
      ))
    }

internal val Res.string.feature_send_interbank_transfer_successful: StringResource by lazy {
      StringResource("string:feature_send_interbank_transfer_successful", "feature_send_interbank_transfer_successful", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5310, 78),
      ))
    }

internal val Res.string.feature_send_interbank_verified: StringResource by lazy {
      StringResource("string:feature_send_interbank_verified", "feature_send_interbank_verified", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5471, 51),
      ))
    }

internal val Res.string.feature_send_interbank_verified_recipient: StringResource by lazy {
      StringResource("string:feature_send_interbank_verified_recipient", "feature_send_interbank_verified_recipient", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5389, 81),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_send_interbank_account", Res.string.feature_send_interbank_account)
  map.put("feature_send_interbank_account_type", Res.string.feature_send_interbank_account_type)
  map.put("feature_send_interbank_acknowledgement_section", Res.string.feature_send_interbank_acknowledgement_section)
  map.put("feature_send_interbank_amount", Res.string.feature_send_interbank_amount)
  map.put("feature_send_interbank_amount_exceeds_balance", Res.string.feature_send_interbank_amount_exceeds_balance)
  map.put("feature_send_interbank_amount_label", Res.string.feature_send_interbank_amount_label)
  map.put("feature_send_interbank_amount_transferred", Res.string.feature_send_interbank_amount_transferred)
  map.put("feature_send_interbank_attempted_amount", Res.string.feature_send_interbank_attempted_amount)
  map.put("feature_send_interbank_available_balance", Res.string.feature_send_interbank_available_balance)
  map.put("feature_send_interbank_available_balance_label", Res.string.feature_send_interbank_available_balance_label)
  map.put("feature_send_interbank_back_to_home", Res.string.feature_send_interbank_back_to_home)
  map.put("feature_send_interbank_balance", Res.string.feature_send_interbank_balance)
  map.put("feature_send_interbank_bank", Res.string.feature_send_interbank_bank)
  map.put("feature_send_interbank_cancel", Res.string.feature_send_interbank_cancel)
  map.put("feature_send_interbank_choose_account_to_send", Res.string.feature_send_interbank_choose_account_to_send)
  map.put("feature_send_interbank_confirm_pay", Res.string.feature_send_interbank_confirm_pay)
  map.put("feature_send_interbank_contact_support", Res.string.feature_send_interbank_contact_support)
  map.put("feature_send_interbank_continue", Res.string.feature_send_interbank_continue)
  map.put("feature_send_interbank_date", Res.string.feature_send_interbank_date)
  map.put("feature_send_interbank_description", Res.string.feature_send_interbank_description)
  map.put("feature_send_interbank_download_receipt", Res.string.feature_send_interbank_download_receipt)
  map.put("feature_send_interbank_edit", Res.string.feature_send_interbank_edit)
  map.put("feature_send_interbank_edit_transfer", Res.string.feature_send_interbank_edit_transfer)
  map.put("feature_send_interbank_enter_amount", Res.string.feature_send_interbank_enter_amount)
  map.put("feature_send_interbank_enter_phone_number", Res.string.feature_send_interbank_enter_phone_number)
  map.put("feature_send_interbank_enter_phone_to_search", Res.string.feature_send_interbank_enter_phone_to_search)
  map.put("feature_send_interbank_error", Res.string.feature_send_interbank_error)
  map.put("feature_send_interbank_error_amount_greater_than_zero", Res.string.feature_send_interbank_error_amount_greater_than_zero)
  map.put("feature_send_interbank_error_enter_amount", Res.string.feature_send_interbank_error_enter_amount)
  map.put("feature_send_interbank_error_enter_description", Res.string.feature_send_interbank_error_enter_description)
  map.put("feature_send_interbank_error_failed_to_search_recipient", Res.string.feature_send_interbank_error_failed_to_search_recipient)
  map.put("feature_send_interbank_error_invalid_amount", Res.string.feature_send_interbank_error_invalid_amount)
  map.put("feature_send_interbank_error_phone_number_digits", Res.string.feature_send_interbank_error_phone_number_digits)
  map.put("feature_send_interbank_error_select_recipient", Res.string.feature_send_interbank_error_select_recipient)
  map.put("feature_send_interbank_error_select_sender_account", Res.string.feature_send_interbank_error_select_sender_account)
  map.put("feature_send_interbank_exchange_rate_info", Res.string.feature_send_interbank_exchange_rate_info)
  map.put("feature_send_interbank_failed", Res.string.feature_send_interbank_failed)
  map.put("feature_send_interbank_found_recipients", Res.string.feature_send_interbank_found_recipients)
  map.put("feature_send_interbank_from_account", Res.string.feature_send_interbank_from_account)
  map.put("feature_send_interbank_from_account_label", Res.string.feature_send_interbank_from_account_label)
  map.put("feature_send_interbank_i_acknowledged", Res.string.feature_send_interbank_i_acknowledged)
  map.put("feature_send_interbank_id", Res.string.feature_send_interbank_id)
  map.put("feature_send_interbank_no_accounts", Res.string.feature_send_interbank_no_accounts)
  map.put("feature_send_interbank_no_accounts_available", Res.string.feature_send_interbank_no_accounts_available)
  map.put("feature_send_interbank_no_recipients_found", Res.string.feature_send_interbank_no_recipients_found)
  map.put("feature_send_interbank_no_results", Res.string.feature_send_interbank_no_results)
  map.put("feature_send_interbank_office", Res.string.feature_send_interbank_office)
  map.put("feature_send_interbank_ok", Res.string.feature_send_interbank_ok)
  map.put("feature_send_interbank_oops", Res.string.feature_send_interbank_oops)
  map.put("feature_send_interbank_preview_transfer", Res.string.feature_send_interbank_preview_transfer)
  map.put("feature_send_interbank_retry_transfer", Res.string.feature_send_interbank_retry_transfer)
  map.put("feature_send_interbank_review_transfer", Res.string.feature_send_interbank_review_transfer)
  map.put("feature_send_interbank_review_transfer_button", Res.string.feature_send_interbank_review_transfer_button)
  map.put("feature_send_interbank_search_recipient", Res.string.feature_send_interbank_search_recipient)
  map.put("feature_send_interbank_select_account", Res.string.feature_send_interbank_select_account)
  map.put("feature_send_interbank_select_your_account", Res.string.feature_send_interbank_select_your_account)
  map.put("feature_send_interbank_success", Res.string.feature_send_interbank_success)
  map.put("feature_send_interbank_terms_acknowledged", Res.string.feature_send_interbank_terms_acknowledged)
  map.put("feature_send_interbank_terms_acknowledged_description", Res.string.feature_send_interbank_terms_acknowledged_description)
  map.put("feature_send_interbank_to_account", Res.string.feature_send_interbank_to_account)
  map.put("feature_send_interbank_to_account_interbank", Res.string.feature_send_interbank_to_account_interbank)
  map.put("feature_send_interbank_to_account_label", Res.string.feature_send_interbank_to_account_label)
  map.put("feature_send_interbank_today", Res.string.feature_send_interbank_today)
  map.put("feature_send_interbank_transaction_date_label", Res.string.feature_send_interbank_transaction_date_label)
  map.put("feature_send_interbank_transaction_failed", Res.string.feature_send_interbank_transaction_failed)
  map.put("feature_send_interbank_transaction_reference", Res.string.feature_send_interbank_transaction_reference)
  map.put("feature_send_interbank_transfer_amount", Res.string.feature_send_interbank_transfer_amount)
  map.put("feature_send_interbank_transfer_completed", Res.string.feature_send_interbank_transfer_completed)
  map.put("feature_send_interbank_transfer_details", Res.string.feature_send_interbank_transfer_details)
  map.put("feature_send_interbank_transfer_failed", Res.string.feature_send_interbank_transfer_failed)
  map.put("feature_send_interbank_transfer_successful", Res.string.feature_send_interbank_transfer_successful)
  map.put("feature_send_interbank_verified", Res.string.feature_send_interbank_verified)
  map.put("feature_send_interbank_verified_recipient", Res.string.feature_send_interbank_verified_recipient)
}
